import { useState, useEffect } from "react";
import { SketchMarkerEditor } from "ui-components";

import {
	useSetActive,
	useSelectSketch,
	useSelectFeatureId,
	useSketchGeojson,
	useIsNewSketch,
	useDeleteFeature,
	useUpdateSketchGeojson,
} from "~map-view/states/sketch";

interface Props {
	active: string;
}

export const MarkerEditor = ({ active }: Props) => {
	const updateSketchGeojson = useUpdateSketchGeojson();
	const deleteFeature = useDeleteFeature();
	const sketchGeojson = useSketchGeojson();
	const selectFeatureId = useSelectFeatureId();
	const isNewSketch = useIsNewSketch();
	const selectSketch = useSelectSketch();
	const setActive = useSetActive();
	const [markerIcon, setMarkerIcon] = useState<string>("pin-1.png");

	useEffect(() => {
		if (selectFeatureId && sketchGeojson && active === "marker") {
			const values = { iconUrl: markerIcon };
			updateSketchGeojson(values, "icon");
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectFeatureId, active, updateSketchGeojson]);

	const handleSave = () => {
		if (isNewSketch(selectSketch?.id ?? "")) setActive("Create Sketch");
		else setActive("edit-sketch");
	};

	const handleDelete = () => {
		deleteFeature(selectFeatureId);
		if (isNewSketch(selectSketch?.id ?? "")) setActive("Create Sketch");
		else setActive("edit-sketch");
	};

	const handleSelectIcon = (icon: string) => {
		if (!selectFeatureId || !sketchGeojson) return;
		const values = { iconUrl: icon };
		updateSketchGeojson(values, "icon");
		setMarkerIcon(icon);
	};

	if (active === "marker") {
		return (
			<SketchMarkerEditor
				markerIcon={markerIcon}
				onIconClick={handleSelectIcon}
				onSave={handleSave}
				onDelete={handleDelete}
			/>
		);
	} else return null;
};
